import * as React from 'react';

import { capitalize } from 'lodash';

import Heading from 'components/Heading';
import Icon from 'components/Icon';
import Link from 'components/Link';
import Table from 'components/Table';
import Text from 'components/Text';
import Tooltip from 'components/Tooltip';
import TooltipTrigger from 'components/TooltipTrigger';
import EventTracking from 'lib/EventTracking';

import { AdminSchoolSisDashboard_organizations_sisSyncOverview_issueSummaries as IssueSummary } from 'admin/rostering/queries/__generated__/AdminSchoolSisDashboard';

import './styles/AdminSchoolSisDashboardIssueTable.scss';

type Props = {
  type: string;
  subtext: React.ReactNode;
  issues: IssueSummary[];
  orgUuid: string;
};

const AdminSchoolSisDashboardIssueTable = (props: Props) => {
  const { type, subtext, issues, orgUuid } = props;
  const title = `${type}s`;
  const handleLinkClicked = () => {
    EventTracking.track('rostering.errors.downloaded.individual', {
      organization_uuid: orgUuid,
    });
  };

  const entityName = (affectedType: string) => {
    if (affectedType === 'group') {
      return 'Class';
    }
    return capitalize(affectedType);
  };

  return (
    <section className="AdminSchoolSisDashboardIssueTable">
      <div className="AdminSchoolSisDashboardIssueTable-header">
        <Heading level="2" levelStyle="3">
          {title}
        </Heading>
        {subtext}
      </div>
      <Table
        head={
          <tr>
            <th>Count</th>
            <th>Entity</th>
            <th>{type}</th>
            <th>CSV</th>
          </tr>
        }>
        <tbody>
          {issues.map((i: IssueSummary) => {
            const { affectedCount, affectedType, description, downloadUrl, resolution } = i;

            return (
              <tr key={description}>
                {/* Count */}
                <td>{affectedCount}</td>
                {/* Entity */}
                <td>{entityName(affectedType)}</td>
                {/* Type */}
                <td>
                  <TooltipTrigger placement="top" tooltip={<Tooltip>{resolution}</Tooltip>}>
                    <Text
                      className="AdminSchoolSisDashboardIssueTable-description"
                      decoration="dashes">
                      {description}
                    </Text>
                  </TooltipTrigger>
                </td>
                {/* CSV Url */}
                <td>
                  {downloadUrl && (
                    <Link
                      href={downloadUrl}
                      target="_blank"
                      tooltip="Download CSV"
                      tooltipPlacement="left"
                      onClick={handleLinkClicked}>
                      <Icon name="arrow-down-bar" />
                    </Link>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </section>
  );
};

export default AdminSchoolSisDashboardIssueTable;
